import React from 'react'
import classNames from 'classnames'
import { image } from '../../../../utils/data/baseUrl'
import { useTranslation } from '../../../../translations'
import { icons } from '../../../../constants/rewards'

const Reward = React.forwardRef(function ({ type, value, mod, isPlus = true, src }, ref) {
  const { t } = useTranslation()
  return (
    <div className={classNames('reward', { [`reward_${type}`]: type, [`reward_${mod}`]: mod })}>
      <div className={'reward__icon'}>
        <img src={src ?? image(icons[type])} />
      </div>
      {value && <div className={'reward__value'}>{`${isPlus ? '+' : ''}${t(value)}`}</div>}
    </div>
  )
})

export default Reward
